export const getters = {
    CATEGORY_LIST: (state) => state.category_list
}
